import styled from 'styled-components';
import { color, fontSize, screen, spacing } from 'theme';

type WikiCardProps = {
  iconPath: string;
  title: string;
  subtitle: string;
  ml?: string;
};

const Card = styled.div`
  background: ${color('white')};
  border-radius: 12px;
  padding: ${spacing('md')};
  box-shadow: 0;
  display: flex;
  align-items: center;
  max-width: 400px;
  height: auto;
  font-size: ${fontSize('xs')};

  @media (max-width: ${screen('sm')}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: ${spacing('xs')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('sm')};
  }
`;

const IconWrapper = styled.div`
  padding-right: ${spacing('lg')};
  width: 48px;
  align-items: center;
  display: flex;
  justify-content: center;

  @media (max-width: ${screen('sm')}) {
    width: 25%;
    padding-right: 0;
  }
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs2')};
`;

const Title = styled.h3`
  font-weight: 600;
  margin: 0;
  color: #433f52;
`;

const Subtitle = styled.p`
  color: #433f52;
  margin: 0;
`;

export const WikiCard = ({
  iconPath,
  title,
  subtitle,
  ml = '0'
}: WikiCardProps) => (
  <Card>
    <IconWrapper>
      <img src={iconPath} alt="" />
    </IconWrapper>
    <TextGroup>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </TextGroup>
  </Card>
);
